export const giaVon = {
  title: '成本',
  titles: {
    list: '货批成本列表',
    edit: '更新货批成本',
    config: '更新固定成本费用',
  },
  fields: {
    maLoHang: '货批编码',
    tenSanPham: '产品名称',
    tenKhachHang: '客户',
    maContainer: '柜号',
    thanhTienVon2: '成本金额 2',
    thanhTienChot: '成交金额',
    laiChuaThue: '税前利润',
    mucCanhBao: '预警级别',
    actions: '操作',
    phiGiaVonCoDinh: '固定成本费用',
  },
  filter: {
    all: '全部',
    searchPlaceholder: '按货批编码/产品名称搜索',
    fromDate: '开始日期',
    toDate: '结束日期',
    warningLevel: '预警级别',
  },
  update: {
    chiPhiDauTQ: '中国端费用',
    phiShip: '运输费',
    phiKhac: '其他费用',
    thueNKThuKhach: '向客户收取进口税',
    thueVATThuKhach: '向客户收取增值税',
    thueKhac: '其他税费',
    phanTramUTNK: '进口委托百分比',
    utnk: '进口委托费',
    chiPhiKTCL: '质检费',
  },
  actions: {
    exportExcel: '导出 Excel',
    config: '固定费用',
  },
  messages: {
    noData: '暂无数据',
  },
}
